import { Expose, Transform, Type } from "class-transformer";
import { UpdateDeliveryNoteLineDto } from "@/core/features/delivery-notes/update-delivery-note-line.dto";
import { parseAppDate } from "@/utils/dates/dateFormats";

/**
 * Purchase orders are not editable through this DTO: they are linked and unlinked with dedicated endpoints.
 */
export class UpdateDeliveryNoteDto {
  @Expose()
  id: string;

  @Expose()
  code: string;

  @Expose()
  @Type(() => UpdateDeliveryNoteLineDto)
  lines: UpdateDeliveryNoteLineDto[] = [];

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date: string;
}
